// extracted by mini-css-extract-plugin
module.exports = {"beautySimplification":"Breadcrumbs_beautySimplification__lcmh5","breadcrumbsPositionTwo":"Breadcrumbs_breadcrumbsPositionTwo__se47c"};